import { useCallback, useState } from 'react';
import storage from './storage';
import cookies from './cookies';

export default function useStorage(key) {
  const [state, setState] = useState(() => storage.get(key));

  const set = useCallback(newValue => {
    cookies.setItem( key, JSON.stringify(newValue))
    // storage.set(key, newValue);
    setState(newValue);
  }, [key]);

  const remove = useCallback(() => {
    cookies.removeItem(key);
    // storage.remove(key);
    setState(undefined);
  }, [key]);

  return [state, set, remove];
}